import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './LandingPage.css';

// Import images
const logoWhite = '/images/landing/paze_-_logo_-_png_-_white_1.png';
const heroImage = '/images/landing/hero_girl.png';
const phoneApp1 = '/images/landing/home1_1.png';
const carEconomy = '/images/landing/2004-toyota-corolla-1nxbr32e84z317298-1-removebg-preview_1.png';
const carPriority = '/images/landing/min_2.png';
const carXL = '/images/landing/hqdefault-removebg-preview_1.png';
const carEco = '/images/landing/527d50ac-4b67-4302-a6f2-a7642a1d47c7-removebg-preview_1.png';
const featurePayment = '/images/landing/flexible_payment.png';
const featureSafety = '/images/landing/whatsapp_image_2025-11-20_at_21_56_43_1.png';
const featurePricing = '/images/landing/whatsapp_image_2025-11-20_at_21_57_40_1.png';
const qrCode = '/images/landing/hellotech-qr-code-1024x1024_1.png';

const LandingPage = () => (
    <div className={s.landingPage}>
        {/* Hero Section */}
        <section className={s.hero}>
            <div className={s.container}>
                <div className={s.heroContent}>
                    <span className={s.tagline}>Ride hailing app</span>
                    <h1 className={s.heroTitle}>Your City, Your Ride</h1>
                    <p className={s.heroSubtitle}>Safe, fast, and reliable.</p>
                    <button className={s.ctaBtn}>
                        Get it <span className={s.chevronRight}>→</span>
                    </button>
                </div>
                <div className={s.heroImage}>
                    <div className={s.heroCircle}>
                        <img src={heroImage} alt="Woman using PazeX app" className={s.heroPhoto} />
                    </div>
                </div>
            </div>
        </section>

        {/* Phone Mockups Section */}
        <section className={s.phoneMockups}>
            <div className={s.container}>
                <button className={s.riderBtn}>Riders</button>
                <div className={s.phonesWrapper}>
                    <img src={phoneApp1} alt="PazeX Rider App" className={s.phoneImage + ' ' + s.phoneLeft} />
                    <img src={phoneApp1} alt="PazeX App Main" className={s.phoneImage + ' ' + s.phoneCenter} />
                    <img src={phoneApp1} alt="PazeX Driver App" className={s.phoneImage + ' ' + s.phoneRight} />
                </div>
                <button className={s.driverBtn}>Drivers</button>
            </div>
        </section>

        {/* Feature Highlights */}
        <section className={s.featureHighlights}>
            <h2 className={s.sectionTitle}>Feature Highlights</h2>
            <div className={s.featureCards}>
                <div className={s.featureCard}>
                    <div className={s.featureImageWrapper}>
                        <img src={featurePayment} alt="Payment Options" className={s.featureImage} />
                    </div>
                    <h3 className={s.featureTitle}>Flexible Payment Options</h3>
                    <p className={s.featureDesc}>Pay your way with cash, card, in-app wallet, or request a driver with a POS machine.</p>
                </div>
                <div className={s.featureCard}>
                    <div className={s.featureImageWrapper}>
                        <img src={featureSafety} alt="Safety" className={s.featureImage} />
                    </div>
                    <h3 className={s.featureTitle}>Safety focused</h3>
                    <p className={s.featureDesc}>Enhanced safety features for secure rides</p>
                </div>
                <div className={s.featureCard}>
                    <div className={s.featureImageWrapper}>
                        <img src={featurePricing} alt="Fair Pricing" className={s.featureImage} />
                    </div>
                    <h3 className={s.featureTitle}>Fair Pricing</h3>
                    <p className={s.featureDesc}>Low fare for riders and best driver commissions</p>
                </div>
            </div>
        </section>

        {/* Ride Options Section */}
        <section className={s.rideOptions}>
            <h2 className={s.sectionTitle}>Every Trip, A Perfect Fit</h2>
            <div className={s.rideCards}>
                <div className={s.rideCard}>
                    <img src={carEconomy} alt="Economy" className={s.carImage} />
                    <h3 className={s.rideTitle}>Economy</h3>
                    <p className={s.rideDesc}>Affordable rides for quick, everyday trips.</p>
                </div>
                <div className={s.rideCard}>
                    <img src={carPriority} alt="Priority" className={s.carImage} />
                    <h3 className={s.rideTitle}>Priority</h3>
                    <p className={s.rideDesc}>Priority cars for a stylish and classy experience.</p>
                </div>
                <div className={s.rideCard}>
                    <img src={carXL} alt="XL" className={s.carImage} />
                    <h3 className={s.rideTitle}>XL</h3>
                    <p className={s.rideDesc}>Comfortable rides with extra space for small groups</p>
                </div>
                <div className={s.rideCard}>
                    <img src={carEco} alt="Eco" className={s.carImage} />
                    <h3 className={s.rideTitle}>Eco</h3>
                    <p className={s.rideDesc}>Top-tier rides with elite comfort and convenience</p>
                </div>
            </div>
        </section>

        {/* How It Works Section */}
        <section className={s.howItWorks}>
            <span className={s.howItWorksBadge}>HOW IT WORKS</span>
            <h2 className={s.sectionTitle}>How PazeX Works for Everyone<br />Made Simple</h2>
            <div className={s.steps}>
                <div className={s.step}>
                    <div className={s.stepNumber}>1</div>
                    <div className={s.stepContent}>
                        <h3 className={s.stepTitle}>Sign Up</h3>
                        <p className={s.stepDesc}>Riders: Create an account to start booking rides.<br />Drivers: Create an account and get verified to start earning.</p>
                    </div>
                </div>
                <div className={s.step}>
                    <div className={s.stepNumber}>2</div>
                    <div className={s.stepContent}>
                        <h3 className={s.stepTitle}>Request or Accept a Ride</h3>
                        <p className={s.stepDesc}>Riders: Enter your destination, see price upfront, and request.<br />Drivers: Receive nearby ride requests and accept instantly.</p>
                    </div>
                </div>
                <div className={s.step}>
                    <div className={s.stepNumber}>3</div>
                    <div className={s.stepContent}>
                        <h3 className={s.stepTitle}>Ride with Safety & Ease</h3>
                        <p className={s.stepDesc}>Riders: Get picked up, track your trip in real-time.<br />Drivers: Navigate easily with in-app maps</p>
                    </div>
                </div>
            </div>
        </section>

        {/* Testimonials Section */}
        <section className={s.testimonials}>
            <h2 className={s.sectionTitle}>What Our Users<br />Are Saying</h2>
            <p className={s.testimonialSubtitle}>Discover the impact our platform has had on our users' lives. Hear their stories and experiences firsthand!</p>
            <div className={s.testimonialCards}>
                <div className={s.testimonialCard + ' ' + s.featured}>
                    <p className={s.quote}>"Driving with Paze-X has been a game-changer. The commission rates are fair, and I get paid instantly after rides. Finally, a platform that respects drivers"</p>
                    <p className={s.author}>John, Abuja</p>
                </div>
                <div className={s.testimonialCard}>
                    <p className={s.quote}>"I've tried different ride apps, but Paze-X feels safer and more transparent. I love that I can pay with POS without worrying about card details"</p>
                    <p className={s.author}>Chinwe, Lagos</p>
                </div>
                <div className={s.testimonialCard}>
                    <p className={s.quote}>"Even before the full launch, I can see how much thought has gone into Paze-X. It's clear they want to build something that really works for both drivers and riders."</p>
                    <p className={s.author}>Sarah, Port Harcourt</p>
                </div>
            </div>
            <button className={s.viewMoreBtn}>View more</button>
        </section>

        {/* Download Section */}
        <section className={s.downloadSection}>
            <div className={s.downloadCard + ' ' + s.riderDownload}>
                <div className={s.downloadContent}>
                    <h3>Download The<br />Rider App</h3>
                    <div className={s.appButtons}>
                        <button className={s.appBtn}>Get on App Store</button>
                        <button className={s.appBtn}>Get on Google Play</button>
                    </div>
                </div>
                <div className={s.qrSection}>
                    <img src={qrCode} alt="QR Code" className={s.qrCode} />
                    <p>Scan QR code to Download</p>
                </div>
            </div>
            <div className={s.downloadCard + ' ' + s.driverDownload}>
                <div className={s.downloadContent}>
                    <h3>Download The<br />Driver App</h3>
                    <div className={s.appButtons}>
                        <button className={s.appBtn}>Get on App Store</button>
                        <button className={s.appBtn}>Get on Google Play</button>
                    </div>
                </div>
                <div className={s.qrSection}>
                    <img src={qrCode} alt="QR Code" className={s.qrCode} />
                    <p>Scan QR code to Download</p>
                </div>
            </div>
        </section>

        {/* FAQ Section */}
        <section className={s.faq}>
            <h2 className={s.sectionTitle}>FAQs</h2>
            <div className={s.faqList}>
                <details className={s.faqItem}>
                    <summary className={s.faqQuestion}>How do I book a ride on Paze-X?</summary>
                    <p className={s.faqAnswer}>Open the Paze-X Rider App, enter your destination, choose your ride type, and confirm your booking. A nearby driver will be matched with you instantly. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                </details>
                <details className={s.faqItem}>
                    <summary className={s.faqQuestion}>In which cities is Paze-X currently available?</summary>
                    <p className={s.faqAnswer}>Paze-X is currently available in Lagos, Abuja, Port Harcourt, and Ibadan. We are rapidly expanding to more cities across Nigeria. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut enim ad minim veniam, quis nostrud exercitation.</p>
                </details>
                <details className={s.faqItem}>
                    <summary className={s.faqQuestion}>How does Paze-X ensure safety for riders and drivers?</summary>
                    <p className={s.faqAnswer}>We implement comprehensive safety features including driver verification, real-time trip tracking, emergency SOS button, and 24/7 support. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit.</p>
                </details>
                <details className={s.faqItem}>
                    <summary className={s.faqQuestion}>How long do payments take to process?</summary>
                    <p className={s.faqAnswer}>Payments are processed instantly for card and in-app wallet. Bank transfers typically take 1-2 business days. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Excepteur sint occaecat cupidatat non proident.</p>
                </details>
                <details className={s.faqItem}>
                    <summary className={s.faqQuestion}>What payment options are available?</summary>
                    <p className={s.faqAnswer}>We accept cash, debit/credit cards, in-app wallet, and POS terminals in vehicles. You can choose your preferred payment method for each trip. Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                </details>
            </div>
        </section>

        {/* Contact Section */}
        <section className={s.contact}>
            <h2 className={s.sectionTitle}>Get in Touch with PazeX</h2>
            <button className={s.contactUsBtn}>
                Contact
            </button>
        </section>

        {/* Footer */}
        <footer className={s.footer}>
            <div className={s.container}>
                <div className={s.footerLogo}>
                    <img src={logoWhite} alt="PazeX" className={s.footerLogoImg} />
                    <p className={s.footerDesc}>Paze-X is a smart ride-hailing app that connects riders and drivers with safe, affordable, and flexible trips designed for every lifestyle</p>
                </div>
                <div className={s.footerLinks}>
                    <a href="#drivers">Drivers</a>
                    <a href="#riders">Riders</a>
                    <a href="#safety">Safety</a>
                    <a href="#faqs">FAQs</a>
                    <a href="#contact">Contact Us</a>
                </div>
                <div className={s.footerContact}>
                    <p>Nigeria Office: No 4 Isaac John Gra Ikeja Lagos, Nigeria</p>
                    <p>support@paze-x.com</p>
                </div>
                <div className={s.footerBottom}>
                    <div className={s.footerLegal}>
                        <a href="/terms">Terms and Conditions</a>
                        <a href="/privacy">Privacy Policy</a>
                    </div>
                    <p className={s.copyright}>Copyright © 2026 PazeX. All rights reserved.</p>
                </div>
            </div>
        </footer>
    </div>
);

export default withStyles(s)(LandingPage);
